import React, { useState } from 'react'
import { Badge, Rate } from "antd";
import { EnvironmentFilled, EnvironmentOutlined } from '@ant-design/icons';
import { getColor } from '../LocalSEO';
import { KeywordResultDistanceSummary } from '../../_common/GridComponents';

export const Marker = ({ lat, lng, location, zoom, onClick }: any) => {

    //const [circleVisible, setCircleVisible] = useState(false);
    const [panelVisible, setPanelVisible] = useState(false);
    const isOwn = !!location.reference;
    const statusColor = getColor(location.distanceDiff);

    const handleMouseEnter = () => {
        setPanelVisible(true);                
    };
    
    const handleMouseLeave = () => {
        setPanelVisible(false);                
    };

    return (
        <div style={{ position: 'absolute', left: '50%', top: '50%', transform: 'translate(-50%, -50%)', zIndex: isOwn || panelVisible ? 100 : 1}}>
            
            {panelVisible && (
                <div style={{
                    position: 'absolute',
                    transform: 'translate(-50%, -50%)',
                    width: location.localPackMaxDistance * 0.01 * Math.pow(2, (zoom + 1) - 10),
                    height: location.localPackMaxDistance * 0.01 * Math.pow(2, (zoom + 1) - 10),
                    borderRadius: '50%',
                    background: isOwn ? 'blue' : 'teal',
                    opacity: isOwn ? 0.1 : 0.2,
                }} />
            )}
            
            <div style={{ position: 'absolute', transform: 'translate(-50%, -50%)'}} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} onClick={onClick}> 
                <Badge
                    size="small"
                    count={
                        <small style={{
                            padding: '0px 5px',
                            color: isOwn ? 'white' : statusColor,
                            border: isOwn ? 'solid 1.5px white' : `solid 1.5px color-mix(in srgb, ${statusColor} 55%, white)`,
                            background: isOwn ? statusColor : 'white',
                            borderRadius: '25px',
                        }}>
                            <b>{(100 * location.localPackPercent).toFixed(0)}%</b>
                        </small>
                    }
                    color={statusColor}
                >
                {isOwn ?
                    <EnvironmentFilled style={{ fontSize: '26px', color: 'blue', cursor: 'pointer'}} /> 
                    :
                    <EnvironmentOutlined style={{ fontSize: '24px', color: statusColor, cursor: 'pointer'}} /> 
                }
                </Badge>
            </div>  

            <div>
                <div>
                    {panelVisible && 
                        <div style={{background:'rgba(0, 0, 0, 0.75)', borderRadius:'10px', color: 'white', position:'absolute', width:'250px', margin:'5px', padding:'10px'}}>
                            <div style={{fontSize:'14px', color:'GreenYellow'}}><b>{location.name}</b></div>                                                    
                            <Rate value={location.rating} style={{fontSize:'14px', marginTop:'5px'}} allowHalf/>  
                            {/*<span style={{marginLeft:'15px'}}>{location.userRatingsTotal} reseñas</span>*/}
                            <div style={{fontSize:'14px', marginTop:'5px'}}>
                                <KeywordResultDistanceSummary metric={location}/>
                                {/*<Tag style={{borderRadius:'10px'}} color={getColor(location.distanceDiff)}><b><b>Posición Media:</b> {location.popularityPosAVG.toFixed(1)} <CaretIncrement value={location.distanceDiff} numberOfDecimals={1} color={'white'}/></b></Tag>  */}
                                <div style={{marginTop:'15px'}}><b>Localpack: </b></div>
                                <div style={{marginLeft:'15px'}}>- Presencia {(100 * location.localPackPercent).toFixed(0)}%</div>
                                <div style={{marginLeft:'15px'}}>- Alcance: {location.localPackMaxDistance.toFixed(1)} mts.</div>
                            </div>
                    </div>}                    
                </div>
            </div>
        </div>        
    )
}
